import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { createMyDiscount, updateMyDiscount } from "../../api/discounts";
import { DiscountForm } from "./DiscountForm";
import { Discount } from "@/types/global";

export function DiscountModal({
  initialData = {} as Discount,
  companyId,
  isOpen,
  onClose,
  storeId,
  refetch,
}: {
  initialData: Discount;
  companyId: number;
  isOpen: boolean;
  onClose: () => void;
  storeId: number;
  refetch: () => void;
}) {
  return (
    <Modal
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {initialData?.name ? initialData.name : "Criando Desconto"}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <DiscountForm
            initialData={initialData}
            companyId={companyId}
            storeId={storeId}
            onClose={onClose}
            nextText="Salvar"
            updateFunc={updateMyDiscount}
            createFunc={createMyDiscount}
            onNext={() => {
              refetch();
              onClose();
            }}
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
